import { motion } from "framer-motion";
import { BRAND } from "@/data/products";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-cream-100 relative overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-[1fr_1.05fr] gap-14 lg:gap-24 items-center">
        {/* Left: arch image stack */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          <div className="relative">
            <div className="absolute inset-0 -m-3 border border-gold/30 rounded-t-[50%_25%] pointer-events-none" />
            <div className="relative overflow-hidden bg-cream-200 rounded-t-[50%_25%]">
              <img
                src="https://customer-assets-jt897jd0.emergentagent.net/job_vardaan-divine/artifacts/t7vno4xa_IMG_20251220_104031.jpg"
                alt="Vardaan Arts artisan work"
                className="w-full h-[500px] md:h-[600px] object-cover"
              />
            </div>
          </div>

          {/* Owner card */}
          <div className="absolute -right-4 -bottom-8 md:right-8 md:-bottom-12 max-w-[300px] bg-cream-100 border border-gold/40 p-6 shadow-xl">
            <div className="text-[10px] tracking-[0.28em] uppercase text-gold-dark">
              Founder
            </div>
            <div className="font-serif text-2xl text-ink mt-1">
              {BRAND.owner}
            </div>
            <p className="text-ink-soft text-sm mt-3 leading-relaxed">
              "Marble is patient. It waits for the hand that respects it. Every
              piece we make is a prayer in stone."
            </p>
          </div>
        </motion.div>

        {/* Right: content */}
        <div>
          <div className="text-[11px] tracking-[0.32em] uppercase text-gold-dark mb-5">
            — About Vardaan Arts
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ink leading-[1.05]">
            Where devotion
            <br />
            meets <span className="italic gold-text">artistry.</span>
          </h2>

          <p className="text-ink-soft mt-8 text-base leading-relaxed max-w-xl">
            Vardaan Arts was founded in {BRAND.established} by {BRAND.owner} in
            Thane, Maharashtra, with a single conviction — that a temple, a
            statue or a sculpture should carry the same reverence as the deity
            it honours. Today, our karigars carve full-scale marble mandirs,
            deity idols, fountains and inlay art that are shipped to homes and
            temples worldwide.
          </p>

          <div className="grid grid-cols-2 gap-4 mt-10 max-w-lg">
            <div className="border border-gold/40 p-5">
              <div className="text-[10px] tracking-[0.24em] uppercase text-gold-dark">
                Material
              </div>
              <div className="font-serif text-lg text-ink mt-2">
                Makrana Grade 1
              </div>
            </div>
            <div className="border border-gold/40 p-5">
              <div className="text-[10px] tracking-[0.24em] uppercase text-gold-dark">
                Approach
              </div>
              <div className="font-serif text-lg text-ink mt-2">
                Hand-carved
              </div>
            </div>
            <div className="border border-gold/40 p-5">
              <div className="text-[10px] tracking-[0.24em] uppercase text-gold-dark">
                Orders
              </div>
              <div className="font-serif text-lg text-ink mt-2">
                Custom pre-order
              </div>
            </div>
            <div className="border border-gold/40 p-5">
              <div className="text-[10px] tracking-[0.24em] uppercase text-gold-dark">
                Delivery
              </div>
              <div className="font-serif text-lg text-ink mt-2">
                100+ Countries
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
